import { HotTable } from '@handsontable/react';
import { IList } from 'core/API/listApi';

export const RATINGS_TARGET_CRITERIA = ['average ratings', 'Number of voters', 'Number of recent voters'];

export const UNITS = ['characters', 'units', 'words'];

export const CHARACTERSDATA = ['allergens', 'nutritions', 'title', 'description'];
export const UNITDATA = [
    'average_ratings',
    'number_ratings',
    'nutritions',
    'images',
    'ingredients',
    'libelles',
    'ratings',
    'reviews',
    'video',
    'bullet_points',
    'enhanced_content',
    'max_length_percent',
];

export const FIELDCRITERIA = [...CHARACTERSDATA, ...UNITDATA, 'total'];

export const FILTERED_INDICATOR_CRITERIA = [
    'list.array.description',
    'list.array.bullet_points',
    'list.array.title',
    'list.array.ingredients',
    'list.array.average_ratings',
    'list.array.number_ratings',
    'list.array.number_images',
    'list.array.number_videos',
];

export const PDP_INDICATOR_THRESHOLD_CRITERIA_WORDS = [
    'list.array.allergens',
    'list.array.description',
    'list.array.title',
];
export const PDP_INDICATOR_THRESHOLD_CRITERIA_UNITS = [
    'list.array.average_ratings',
    'list.array.number_ratings',
    'list.array.images',
    'list.array.number_videos',
    'list.array.ingredients',
    'list.array.bullet_points',
    'list.array.enhanced_content',
    'list.array.vto',
    'list.array.number_reviews',
    'list.array.nutritions',
    'list.array.video',
];

export const PDP_INDICATOR_CRITERIA_WORDS = ['list.array.allergens', 'list.array.description', 'list.array.title'];

export const PDP_INDICATOR_CRITERIA_UNITS = [
    'list.array.average_ratings',
    'list.array.bullet_points',
    'list.array.enhanced_content',
    'list.array.vto',
    'list.array.images',
    'list.array.ingredients',
    'list.array.number_ratings',
    'list.array.number_reviews',
    'list.array.nutritions',
    'list.array.video',
];

export const PDP_INDICATOR_CRITERIA_WORDS_LIGHT = ['list.array.title', 'list.array.description'];

export const PDP_INDICATOR_CRITERIA_UNITS_LIGHT = ['list.array.bullet_points', 'list.array.nutriscore'];

export const PERFCT_SHELF_CRITERIA = [
    'list.array.allergens',
    'list.array.images',
    'list.array.ingredients',
    'list.array.libelles',
    'list.array.description',
    'list.array.ratings',
    'list.array.reviews',
    'list.array.total',
];

export const PRODUCT_SCORE_CRITERIA = [
    'list.array.Average ratings',
    'list.array.Number of ratings',
    'list.array.Number of recent ratings',
];

export const UNITS_CHARS = ['list.array.characters', 'list.array.words', 'list.array.paragraphs'];
export const UNITS_UNITS = ['list.array.units'];

export const LIST_FIELDS = ['id', 'is_private', 'name', 'type', 'upc_type', 'actions'];
export const PREFERED_COLUMN_ORDER: string[] = ['name', 'type', 'upc_type', 'actions'];

export const HIDDEN_COLUMN: string[] = ['id', 'is_private'];

export const MEDIA_WEIGHTING_LIST = [
    'ispromotion',
    'isnotpromotion',
    'ismultibrand',
    'isnotmultibrand',
    'format_banner',
    'format_sponsoredproduct',
    'format_butterfly',
    'format_sliderhomepage',
    'format_bannerhomepage',
    'format_showcase',
    'format_activationretailer',
    'format_vignette',
    'page_search',
    'page_1',
    'page_2',
    'page_3',
    'page_4',
];

export const DEFAULT_LIST: IList = {
    id: 0,
    name: '',
    type: '',
    is_private: false,
    retailers: [],
    frequency: '',
    is_active: true,
    type_unique: false,
    upc_type: '',
    has_all_products: false,
    columns: [],
    data: [],
};

export const GLOBAL_TEMPLATE_PROPS = {
    width: '100%',
    rowHeaders: true,
    rowHeights: 25,
    // filters: true,
    stretchH: 'all',
    height: '40vw',
    contextMenu: true,
    minRows: 1,
    // dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'],
    licenseKey: 'non-commercial-and-evaluation',
} as Partial<HotTable>;
